/**
 * テーブルの見出しタグ
 */

import React from 'react';

type Props = {
  children: React.ReactNode;
  sortable?: boolean; // ソート可能かどうか
  sortOrder?: 'asc' | 'desc' | null; // ソート順（昇順、降順、または非アクティブ）
  onClick?: () => void; // クリックイベント
  className?: string;
};

const Th = ({ children, sortable = false, sortOrder = null, onClick, className }: Props) => {
  return (
    <th className={className}>
      {sortable ? (
        <button
          type='button'
          className='flex w-full cursor-pointer items-center gap-5 px-3 py-2 text-xs font-semibold'
          onClick={onClick}
        >
          <span>{children}</span>
          {/* 並び替えボタン */}
          <div className='flex flex-col'>
            {/* ▲ボタン */}
            <div
              className={`grid size-[12px] place-items-center after:h-[4px] after:w-[8px] after:bg-black after:transition-opacity after:[clip-path:polygon(50%_0,0_100%,100%_100%)] ${
                sortOrder === 'asc' ? 'after:opacity-100' : 'after:opacity-20'
              } hover:after:opacity-80`}
            ></div>
            {/* ▼ボタン */}
            <div
              className={`grid size-[12px] place-items-center after:h-[4px] after:w-[8px] after:bg-black after:transition-opacity after:[clip-path:polygon(50%_100%,0_0,100%_0)] ${
                sortOrder === 'desc' ? 'after:opacity-100' : 'after:opacity-20'
              } hover:after:opacity-80`}
            ></div>
          </div>
          {/* / 並び替えボタン */}
        </button>
      ) : (
        <span className='block px-3 py-[13px] text-left text-xs font-semibold'>{children}</span>
      )}
    </th>
  );
};

export default Th;
